<template>
  <div>
    <div class="row">
      <div class="col-12" style="margin-top: -10px;">
        <div
          style="
            height: 30px;
            line-height: 30px;
            padding-bottom: 32px;
            border-bottom: 2px #cbcbcb solid;
            margin-bottom: 20px;
          "
        >
          <p
            style="
              font-size: 15px;
              font-family: inherit;
              font-weight: 500;
              text-align: center;
              color: #015a6c;
              text-transform: uppercase;
            "
          >
            {{ buildingName }}
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div
          class="text-center section-title dark-green-title"
          style="margin-bottom: 20px; padding: 5px;"
        >
          <span
            class="white-font row-table-font-margins"
            style="
              font-size: 20px;
              font-family: inherit;
              font-weight: 400;
              line-height: 1;
              text-align: center;
            "
            >Expenses and Payments</span
          >
        </div>
      </div>
    </div>
    <graph-reports-totals
      :building-id="buildingId"
      :building-name="buildingName"
      :is-owner="isOwner"
      :total-income="totalIncome"
      :total-expenses="totalExpenses"
      :total-cash-deposit="totalCashDeposit"
      :property-id="propertyId"
      :property-name="propertyName"
    />
    <div class="row pull-center" style="margin-top: 29px;">
      <div class="col-12 form-group">
        <span
          style="
            background-color: #4586c6;
            color: white;
            display: inline-block;
            padding-left: 5px;
            padding-right: 5px;
          "
          ><strong>Filter:</strong></span
        >

        <period-select class="select" id="period" name="period" :building-id="buildingId" v-model="period" />
      </div>
    </div>
    <div style="margin-bottom: 20px;">
      <div class="col-md-4 col-12">
        <div style="text-align: center; font-size: 24px; margin-bottom: 5px;">
          <span class="graph-circle-title dark-green-font"> Total Income </span>
        </div>
        <div
          class="row"
          style="
            left: 50%;
            position: relative;
            margin-left: -112px;
            margin-top: 30px;
          "
        >
          <vc-donut
            thickness="5"
            background="#e4edf3"
            start-angle="-45"
            size="225"
            :sections="sectionsTotalIncome"
          >
            <span class="dark-green-font graph-circle-text">
              {{ totalCollectedPercentage }}% ||
            </span>
            <span class="light-green-font graph-circle-text"
              >{{ totalUncollectedPercentage }}%</span
            >
          </vc-donut>
          <!-- <div class="total-income-chart">
            <div style="margin-bottom: -150px; margin-top: -40px;">€</div>
            {{ totalIncome.toFixed(2) }}
          </div>-->
        </div>
        <div class="row" style="margin-top: 5px;">
          <div
            v-for="section in sectionsTotalIncome"
            :key="section"
            class="col-md-offset-1 col-md-10"
            style="padding-bottom: 0px; padding-top: 5px;"
          >
            <div
              class="total-income-small"
              :style="'background:' + section.color"
            ></div>
            <span
              style="margin-left: 5px; font-size: 17px;"
              :style="'color:' + section.color"
            >
              {{ section.name }}
            </span>
            <div
              style="
                display: inline-block;
                width: 100px;
                padding: 1px;
                padding-right: 5px;
                float: right;
                text-align: right;
              "
              :style="'background:' + section.color"
            >
              <span
                style="
                  text-align: right;
                  font-size: 15px;
                  color: #fff;
                  font-weight: bold;
                "
                >{{ section.amount }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-12">
        <div style="text-align: center; font-size: 24px; margin-bottom: 5px;">
          <span class="purple-font graph-circle-title"> Total Expenses </span>
        </div>
        <div style="position: relative; margin-top: 30px;">
          <vc-donut
            thickness="5"
            background="#e4edf3"
            start-angle="-45"
            size="225"
            :sections="sectionsTotalExpenses"
          >
            <span class="purple-font graph-circle-text">
              {{ totalUnpaidExpensesPercentage }}% ||
            </span>
            <span class="light-green-font graph-circle-text"
              >{{ totalExpensesPaidPercentage }}%</span
            >
          </vc-donut>
          <!--  <div class="creditors-expenses-chart">
            <div style="margin-bottom: -150px; margin-top: -40px;">€</div>
            {{ totalCollected.toFixed(2) }}
          </div>-->
        </div>
        <div class="row" style="margin-top: 5px;">
          <div
            v-for="section in sectionsTotalExpenses"
            :key="section"
            class="col-md-offset-1 col-md-10"
            style="padding-bottom: 0px; padding-top: 5px;"
          >
            <div
              class="total-income-small"
              :style="'background:' + section.color"
            ></div>
            <span
              style="margin-left: 5px; font-size: 17px;"
              :style="'color:' + section.color"
            >
              {{ section.name }}
            </span>
            <div
              style="
                display: inline-block;
                width: 100px;
                padding: 1px;
                padding-right: 5px;
                float: right;
                text-align: right;
              "
              :style="'background:' + section.color"
            >
              <span
                style="
                  text-align: right;
                  font-size: 15px;
                  color: #fff;
                  font-weight: bold;
                "
                >{{ section.amount }}</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 col-12">
        <div style="text-align: center; font-size: 24px; margin-bottom: 5px;">
          <span class="light-green-font graph-circle-title">
            Cash Balance
          </span>
        </div>
        <div style="position: relative; margin-top: 30px;">
          <vc-donut
            background="#e4edf3"
            start-angle="-45"
            size="225"
            thickness="100"
            :sections="sectionsCashBalance"
          >
          </vc-donut>
          <!--<div class="paid-expenses-chart">
            <div style="margin-bottom: -150px; margin-top: -40px;">€</div>
            {{ totalUncollected.toFixed(2) }}
          </div>-->
        </div>
        <div class="row" style="margin-top: 5px;">
          <div
            v-for="section in sectionsCashBalance"
            :key="section"
            class="col-md-offset-1 col-md-10"
            style="padding-bottom: 0px; padding-top: 5px;"
          >
            <div
              class="total-income-small"
              :style="'background:' + section.color"
            ></div>
            <span
              style="margin-left: 5px; font-size: 17px;"
              :style="'color:' + section.color"
            >
              {{ section.name }}
            </span>
            <div
              style="
                display: inline-block;
                width: 100px;
                padding: 1px;
                padding-right: 5px;
                float: right;
                text-align: right;
              "
              :style="'background:' + section.color"
            >
              <span
                style="
                  text-align: right;
                  font-size: 15px;
                  color: #fff;
                  font-weight: bold;
                "
                >{{ section.amount }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div
          class="text-center section-title dark-green-title"
          style="padding: 5px;"
        >
          <span
            class="white-font row-table-font-margins"
            style="
              font-size: 20px;
              font-family: inherit;
              font-weight: 400;
              line-height: 1;
              text-align: center;
            "
            >Total Expenses</span
          >
        </div>
      </div>
    </div>
    <div style="margin-left: 14px; margin-right: 14px;">
      <expenses
        :building-id="buildingId"
        :key="period"
        :period="period"
      ></expenses>
    </div>

    <div class="row">
      <div class="col-12">
        <div
          class="text-center section-title dark-green-title"
          style="padding: 5px;"
        >
          <span
            class="white-font row-table-font-margins"
            style="
              font-size: 20px;
              font-family: inherit;
              font-weight: 400;
              line-height: 1;
              text-align: center;
            "
            >Creditors</span
          >
        </div>
      </div>
    </div>

    <creditors
      :building-id="buildingId"
      :building-name="buildingName"
      :key="period"
      :period="period"
      :dark="false"
    ></creditors>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { authenticationService } from "@/_services";
import { Role } from "@/_helpers";
import { toCurrency } from "@/filters";
export default {
  beforeCreate() {
    this.buildingId = this.$route.params.buildingId;
   // this.buildingName = this.$route.params.buildingName;
    //  alert(this.buildingId)
  },

  data: function () {
    return {
      period: 1,
      buildingId: 0,
     // buildingName: "",
      totalIncome: 0,
      totalUncollected: 0,
      totalCollected: 0,
      totalExpenses: 0,
      totalCreditors: 0,
      totalExpensePayments: 0,
      year: 0,
      totalCashDeposit: 0,
      currentUser: null,
      sectionsTotalIncome: [],
      sectionsTotalExpenses: [],
      sectionsCashBalance: [],
      totalUnpaidExpensesPercentage: 0,
      totalExpensesPaidPercentage: 0,
      totalUnpaidExpenses: 0,
      totalExpensesPaid: 0,
      totalCashBalance: 0,
      totalCashBalancePercentage: 0,
      totalUnpaidExpensesCashPercentage: 0,
      totalUncollectedCashPercentage: 0,
    };
  },
  watch: {
    value(val) {
      this.$emit("update:buildingId", val);
    },
    buildingId(val) {
      this.value = val;
      //this.fetchStatement();
    },
  },
  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
  },
  mounted() {
    this.year = new Date().getFullYear();
    if (this.$route.params.propertyId) {
      this.propertyId = this.$route.params.propertyId;
      this.propertyName = this.$route.params.propertyName;
      this.getProperty();
    } else {
      this.buildingId = this.$route.params.buildingId;
      //alert(this.buildingId);
      this.buildingName = this.$route.params.buildingName;
      this.fetchStatement();
    }
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    isOwner() {
      return this.currentUser && this.currentUser.role === Role.Owner;
    },
  },
  methods: {
    numberInCircleSize: function (number) {
      if (number.toString().length <= 5) {
        return 35;
      } else if (
        (number.toString().length > 5) &
        (number.toString().length <= 7)
      ) {
        return 25;
      } else if (
        (number.toString().length > 7) &
        (number.toString().length <= 10)
      ) {
        return 18;
      } else {
        return 14;
      }
    },
    getProperty: function () {
      var request = "/properties/" + this.propertyId;
      this.$http
        .get(request, {
          id: this.propertyId,
        })
        .then((response) => {
          this.buildingId = response.data.buildingId;
          this.buildingName = response.data.buildingName;
          this.fetchStatement();
        });
    },
    fetchStatement: function () {
      this.chartData = [];
      var request = "/statement/expenses";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.totalCreditors = data.totalCreditors;
          this.totalExpensePayments = data.totalExpensePayments;
        });
      request = "/statement/revenues";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
          this.totalExpenses = data.totalExpenses;
          this.totalUncollected = data.totalUncollected;
          this.totalCollected = data.totalCollected;
          this.totalIncome = data.totalIncome;
          this.totalCashDeposit = data.totalCashDeposit;
          this.totalExpenses = data.totalExpenses;
          this.totalExpensesPaid = data.totalExpensePayments;
          this.totalUnpaidExpensesCashPercentage;
          this.totalUnpaidExpenses =
            this.totalExpenses - this.totalExpensesPaid;
          this.totalCashDeposit = data.totalCashDeposit;
          this.totalCashBalance = data.totalCashBalance;
          var total = this.totalCollected + this.totalUncollected;
          var totalCash =
            this.totalCashBalance +
            this.totalUncollected +
            this.totalUnpaidExpenses;
          this.totalCashBalancePercentage = Math.round(
            (this.totalCashBalance * 100) / totalCash
          );

          this.totalUnpaidExpensesCashPercentage = Math.round(
            (this.totalUnpaidExpenses * 100) / totalCash
          );

          this.totalUncollectedCashPercentage =
            100 -
            (this.totalCashBalancePercentage +
              this.totalUnpaidExpensesCashPercentage);
          this.totalUncollectedPercentage = Math.round(
            (this.totalUncollected * 100) / total
          );

          this.totalCollectedPercentage = 100 - this.totalUncollectedPercentage;

          this.totalExpensesPaidPercentage = Math.round(
            (this.totalExpensesPaid * 100) / this.totalExpenses
          );

          this.totalUnpaidExpensesPercentage =
            100 - this.totalExpensesPaidPercentage;

          this.sectionsTotalIncome.push({
            value: this.totalCollectedPercentage,
            color: "#015a6c",
            name: "Collected Income",
            amount: "€" + toCurrency(this.totalCollected),
          });

          this.sectionsTotalIncome.push({
            value: this.totalUncollectedPercentage,
            color: "#38b2ac",
            name: "Uncollected Income",
            amount: "€" + toCurrency(this.totalUncollected),
          });

          this.sectionsTotalExpenses.push({
            value: this.totalUnpaidExpensesPercentage,
            color: "#9f4777",
            name: "Unpaid Expenses",
            amount: "€" + toCurrency(this.totalUnpaidExpenses),
          });
          this.sectionsTotalExpenses.push({
            value: this.totalExpensesPaidPercentage,
            color: "#38b2ac",
            name: "Expenses Paid",
            amount: "€" + toCurrency(this.totalExpensesPaid),
          });

          this.sectionsCashBalance.push({
            value: this.totalCashBalancePercentage,
            color: "#38b2ac",
            name: "Available Balance",
            amount: "€" + toCurrency(this.totalCashBalance),
          });

          this.sectionsCashBalance.push({
            value: this.totalUncollectedCashPercentage,
            color: "#015a6c",
            name: "Uncollected Income",
            amount: "€" + toCurrency(this.totalUncollected),
          });

          this.sectionsCashBalance.push({
            value: this.totalUnpaidExpensesCashPercentage,
            color: "#9f4777",
            name: "Unpaid Expenses",
            amount: "€" + toCurrency(this.totalUnpaidExpenses),
          });
        });
    },
    changed: function () {
      this.fetchStatement();
    },
  },
};
</script>
